import { computed, inject, Injectable } from '@angular/core';
import { SearchParamsService } from '@educa/educa-ui';

@Injectable({
  providedIn: 'any'
})
export class SearchService {
  readonly searchParamsService = inject(SearchParamsService);

  readonly search = this.searchParamsService.getParam('search', '');
  readonly searchHasValue = computed(() => (this.search()?.length ?? 0) > 0);

  toggleSearch(): void {
    this.searchParamsService.setParams({ search: '' });
  }

  setSearch(search: string): void {
    this.searchParamsService.setParams({ search, page: 0 });
  }
}
